import Post from "./Post";
function UserDetails({posts=[],searchPosts=[],searchString,searchStringAdmin,userFullName,refreshFailed,userName='',isSearchPage}) {
  const newPosts= posts.filter(post => {
    return (
      post.activity.toLowerCase().includes(searchString.toLowerCase()) ||
      post.outcome.toLowerCase().includes(searchString.toLowerCase()) ||
      post.fromTime.toLowerCase().includes(searchString.toLowerCase())
    );
  });
  const newSPosts= searchPosts.filter(post => {
    return (
      post.activity.toLowerCase().includes(searchStringAdmin.toLowerCase()) ||
      post.outcome.toLowerCase().includes(searchStringAdmin.toLowerCase()) ||
      post.fromTime.toLowerCase().includes(searchStringAdmin.toLowerCase())
    );
  });
 
    return (
      <>              
       <div className="fullWidth UserDetails">
          {(userName.toLowerCase()!=="admin")&&(userName!=='') && <div className="text text-info d-flex justify-content-center align-items-center">
              <div className="smallcircle">{(refreshFailed)?'':newPosts.length}</div>
              <div className="smallblacktext">ASSESMENTS</div>
          </div> 
          }
          <div className="text text-info d-flex  justify-content-end align-items-center headertext">{(refreshFailed)?'':userFullName}</div>    
          {(userName.toLowerCase()==="admin") &&(isSearchPage)  && <div className="text text-info d-flex justify-content-center align-items-center">
              <div className="smallcircle">{(refreshFailed)?'':newSPosts.length}</div>
              <div className="smallblacktext">ASSESMENTS</div>
          </div> }
          
       </div>
      </>
    )
  }
  
  export default UserDetails